import { _ as we } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.filter-4e9c9996.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.array.some-0c761b6d.js";
import "./es.date.to-json-b76d522e.js";
import "./es.object.assign-7e79fd7b.js";
import { _ as We, u as Te, q as Ee } from "./export-cdcbfb2b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import { _ as T, T as je } from "./index-f5b44da3.js";
import { c as Ae } from "./index-8b07dec9.js";
import { forwardRef as Re, useRef as re, useState as E, useEffect as oe, useMemo as $e } from "react";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.array.is-array-7a29277f.js";
import { g as _e } from "./getMetrics-953aa4f8.js";
import { a as P } from "./index-5d0f31c6.js";
import "./carousel.js";
import v, { css as S } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./web.set-timeout-72b6430f.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import { jsxs as j, jsx as l, Fragment as qe } from "react/jsx-runtime";
import { InputState as A } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { ScreenReaderOnly as Le } from "./screenReaderOnly.js";
import { useAccessibilityProps as Me } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import { uniqueId as Be } from "./uniqueId.js";
var He = We, Ue = Ee, ae = Te.f;
He({ target: "Object", stat: !0, forced: Object.defineProperty !== ae, sham: !Ue }, {
  defineProperty: ae
});
var Fe = /* @__PURE__ */ v.div.withConfig({
  displayName: "singleSelectInputstyles__Container",
  componentId: "sc-3fs4i2-0"
})(["&.SingleSelect-Container{", ";}"], function(t) {
  var r = t.theme.components.selectInput;
  return S(r.singleSelectInput.Container);
}), le = /* @__PURE__ */ v.span.withConfig({
  displayName: "singleSelectInputstyles__EndAdornmentWrapper",
  componentId: "sc-3fs4i2-1"
})(["&.SingleSelect-EndAdornmentWrapper{", ";}"], function(t) {
  var r = t.theme.components.selectInput;
  return S(r.singleSelectInput.EndAdornmentWrapper);
}), ze = /* @__PURE__ */ v.span.withConfig({
  displayName: "singleSelectInputstyles__CloseIconWrapper",
  componentId: "sc-3fs4i2-2"
})(["&.SingleSelect-CloseIconWrapper{", ";}"], function(t) {
  var r = t.theme.components.selectInput;
  return S(r.singleSelectInput.CloseIconWrapper);
}), Ke = /* @__PURE__ */ v(P).withConfig({
  displayName: "singleSelectInputstyles__CloseIcon",
  componentId: "sc-3fs4i2-3"
})(["&.SingleSelect-CloseIcon{", ";}"], function(t) {
  var r = t.theme.components.selectInput;
  return S(r.singleSelectInput.CloseIcon);
}), ke = /* @__PURE__ */ v.span.withConfig({
  displayName: "singleSelectInputstyles__LeadIconWrapper",
  componentId: "sc-3fs4i2-4"
})(["&.SingleSelect-LeadIconWrapper{", ";}"], function(t) {
  var r = t.theme.components.selectInput;
  return S(r.singleSelectInput.LeadIconWrapper);
}), Ve = ["placeholder", "isDisabled", "options", "onChange", "onBlur", "selected", "onOptionSelect", "size", "required", "maxItems", "className", "labelProp", "infoProp", "trailingText", "isSearchable", "noResultText", "showClear", "isDefaultSelect", "inputState", "helperTextProp", "accessibilityOptions", "exceedOverflow", "startAdornment", "menuDirection", "menuWidth", "_csMaskContent"], Je = "SingleSelect", Xe = function(r, g) {
  var m = r == null ? void 0 : r.trimStart();
  return m = m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), g.filter(function(c) {
    return ("" + c.label + c.value).search(new RegExp(m, "i")) < 0;
  }).map(function(c) {
    return c.value;
  });
}, Ut = /* @__PURE__ */ Re(function(t, r) {
  var g = t.placeholder, m = g === void 0 ? "Select..." : g, c = t.isDisabled, x = c === void 0 ? !1 : c, p = t.options, d = t.onChange, R = t.onBlur, $ = t.selected, f = $ === void 0 ? "" : $, D = t.onOptionSelect, _ = t.size, ie = _ === void 0 ? "medium" : _, q = t.required, L = t.maxItems, se = L === void 0 ? 8 : L, M = t.className, ce = M === void 0 ? "" : M, N = t.labelProp, pe = t.infoProp, ue = t.trailingText, B = t.isSearchable, H = B === void 0 ? !0 : B, de = t.noResultText, U = t.showClear, me = U === void 0 ? !1 : U, F = t.isDefaultSelect, z = F === void 0 ? !1 : F, K = t.inputState, I = K === void 0 ? A.NONE : K, w = t.helperTextProp, k = t.accessibilityOptions, fe = k === void 0 ? {} : k, V = t.exceedOverflow, ve = V === void 0 ? !1 : V, h = t.startAdornment, J = t.menuDirection, Se = J === void 0 ? "down_auto" : J, X = t.menuWidth, ge = X === void 0 ? "280px" : X, Ie = t._csMaskContent, G = we(t, Ve), he = _e({
    label: "SingleSelectInput"
  }), be = re(Be(Je)), b = G.id || be.current, Q = E([]), C = Q[0], Ce = Q[1], Y = E(!1), i = Y[0], W = Y[1], Z = E(""), u = Z[0], y = Z[1], O = re(null), s = {
    label: "",
    value: ""
  }, ye = Me("combobox", Object.assign({
    ariaExpanded: i,
    ariaDisabled: x,
    ariaRequired: (N == null ? void 0 : N.showRequiredIndicator) || q,
    ariaInvalid: A.ERROR === I || A.CAUTION === I,
    ariaHasPopup: "listbox",
    ariaControls: "list-" + b
  }, fe.inputAccessibilityProps)), ee = function(e) {
    if (e.preventDefault(), e.stopPropagation(), y(""), D({
      label: "",
      value: ""
    }), Object.defineProperty(e, "target", {
      value: s
    }), e.target = {
      value: JSON.stringify(s)
    }, d && d(e), O != null && O.current) {
      var n;
      (n = O.current) == null || (n = n.querySelector("input")) == null || n.focus();
    }
  }, Oe = function(e) {
    e.currentTarget.contains(e.relatedTarget) || (Object.defineProperty(e, "target", Object.assign({}, e.target, {
      value: JSON.stringify(s)
    })), R == null || R(e));
  }, Pe = function(e) {
    if (e.code !== "Enter")
      e == null || e.preventDefault();
    else if (i && z) {
      if (e == null || e.preventDefault(), e == null || e.stopPropagation(), p.length === C.length)
        return;
      D(s);
      var n = new Event("change", {});
      Object.defineProperty(n, "target", {
        value: s,
        writable: !0
      }), n.target = {
        value: s
      }, d && d(n), W(!1);
    }
    e.code === "Space" && (e == null || e.stopPropagation()), e.code !== "Tab" && e.code !== "Shift" && !i && W(!0);
  };
  oe(function() {
    if (i) {
      var e = p.some(function(n) {
        return n.label === u;
      });
      e && y("");
    } else {
      var a = f;
      p.forEach(function(n) {
        n.value === f && (a = n.label);
      }), y(a);
    }
  }, [f, i, p]), oe(function() {
    Ce(Xe(u, p));
  }, [u, p]);
  var xe = function() {
    var e = !0, n = Object.assign({}, s), De = p.map(function(o, Ne) {
      var ne = e && f === o.value && !C.includes(o.value);
      return f === o.value && (n = {
        label: o.label,
        value: o.value
      }), z && e && !o.disabled && !C.includes(o.value) && (e = !1, ne = !0, s = {
        label: o.label,
        value: o.value
      }), /* @__PURE__ */ l(T.Item, {
        label: o.label,
        value: o.value,
        description: o.description,
        isSelected: ne,
        disabled: o.disabled || !1
      }, Ne);
    });
    return e && (s = Object.assign({}, n)), De;
  }, te = $e(function() {
    var a = typeof h == "string" ? /* @__PURE__ */ l(P, {
      icon: h
    }) : h;
    return a;
  }, [h]);
  return /* @__PURE__ */ j(Fe, Object.assign({
    className: Ae(["SingleSelect-Container", {
      "SingleSelect-Container--cursor-text": H && i
    }, ce]),
    onBlur: Oe
  }, G, he, {
    children: [/* @__PURE__ */ j(T, {
      className: "no-filter",
      onChange: function(e, n) {
        e == null || e.preventDefault(), D(n), d && d(e);
      },
      menuOpen: i,
      menuDirection: Se,
      handleMenuOpen: function(e) {
        return W(e);
      },
      closeOnSelect: !0,
      isDisabled: x,
      maxItems: se,
      uniqueIdentifier: b,
      hiddenItems: C,
      noResultText: de,
      menuWidth: ge,
      exceedOverflow: ve,
      _csMaskContent: Ie,
      disableAutoFocus: !0,
      children: [/* @__PURE__ */ l(T.Control, {
        children: /* @__PURE__ */ l(je, Object.assign({
          labelProp: Object.assign({
            htmlFor: "control-" + b
          }, N),
          infoProp: Object.assign({
            infoText: "",
            infoType: "tooltip",
            popupTipHeader: "Info"
          }, pe),
          inputState: I,
          trailingText: ue,
          disabled: x,
          textSize: ie,
          isInvalid: !!I,
          helperTextProp: i ? w == null ? void 0 : w.secondaryProp : w,
          required: q,
          id: "control-" + b,
          placeholder: m,
          onChange: function(e) {
            y(e.target.value);
          },
          onKeyUp: Pe,
          value: u,
          ref: O,
          inputRef: r,
          readOnly: !H
        }, ye, {
          endAdornmentProp: {
            endAdornment: i ? /* @__PURE__ */ l(le, {
              className: "SingleSelect-EndAdornmentWrapper",
              children: /* @__PURE__ */ l(P, {
                icon: "caretUp",
                style: {
                  pointerEvents: "none"
                }
              })
            }) : /* @__PURE__ */ j(qe, {
              children: [!i && me && (u == null ? void 0 : u.trim()) && /* @__PURE__ */ l(ze, {
                tabIndex: 0,
                onKeyUp: function(e) {
                  e.preventDefault(), e.stopPropagation(), (e.code === "Enter" || e.code === "Space") && ee(e);
                },
                role: "button",
                "aria-label": "clear",
                className: "SingleSelect-CloseIconWrapper",
                "data-testid": "data-close-icon",
                onClick: ee,
                children: /* @__PURE__ */ l(Ke, {
                  icon: "cancelCloseFilled",
                  className: "SingleSelect-CloseIcon"
                })
              }), /* @__PURE__ */ l(le, {
                className: "SingleSelect-EndAdornmentWrapper",
                children: /* @__PURE__ */ l(P, {
                  icon: "caretDown",
                  style: {
                    pointerEvents: "none"
                  }
                })
              })]
            })
          },
          startAdornmentProp: te ? {
            startAdornment: /* @__PURE__ */ l(ke, {
              className: "SingleSelect-LeadIconWrapper",
              "data-testid": "single-select-lead-icon",
              children: te
            })
          } : void 0
        }))
      }), xe()]
    }), /* @__PURE__ */ l(Le, {
      role: "alert",
      "aria-live": "assertive",
      children: u
    })]
  }));
});
export {
  Ut as S
};
